import { render, staticRenderFns } from "./Coletor.vue?vue&type=template&id=373bcf4e&scoped=true"
import script from "./Coletor.vue?vue&type=script&lang=js"
export * from "./Coletor.vue?vue&type=script&lang=js"
import style0 from "../../../css/crud.css?vue&type=style&index=0&id=373bcf4e&prod&scoped=true&lang=css&external"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "373bcf4e",
  null
  
)

export default component.exports